const breakpoint = 700;

function scroll_timelines__programmes() {
  const shapes = document.querySelectorAll('.programmes_cover svg path[data-path-from], .shapes svg path[data-path-from]');
  if( typeof(shapes) != 'undefined' && shapes != null ) {
    shapes.forEach( element => {
      element.animate(
        {
          d: [
            'path("' + element.dataset.pathFrom + '")',
            'path("' + element.dataset.pathTo + '")',
          ]
        },
        {
          duration: 1, // required, but does nothing
          fill: 'both',
          timeline: new ScrollTimeline({
            scrollOffsets: [
              CSS.px(window.pageYOffset + element.getBoundingClientRect().top + parseInt(element.dataset.offsetFrom)),
              CSS.px(window.pageYOffset + element.getBoundingClientRect().top + parseInt(element.dataset.offsetTo))
            ]
          })
        }
      )
    });
  }
  const timetable_days = document.querySelectorAll('.timetable .cols > div:nth-child(odd)');
  if( window.outerWidth > breakpoint && typeof(timetable_days) != 'undefined' && timetable_days != null ) {
    let i = 0;
    timetable_days.forEach( element => {
      // console.log(i*200);
      element.animate(
        {
          transform: [
            "translateY(0)",
            "translateY(60px)"
          ],
        },
        {
          duration: 1, // required, but does nothing
          fill: 'both',
          timeline: new ScrollTimeline({
            scrollOffsets: [
              CSS.px(window.pageYOffset + element.getBoundingClientRect().top - 800),
              CSS.px(window.pageYOffset + element.getBoundingClientRect().top - 400)
            ]
          })
        }
      )
      i++;
    });
  }
  const multi_active_age_sub_splits = document.querySelectorAll('.multi_active_age_sub_splits .cols > div');
  if( window.outerWidth > breakpoint && typeof(multi_active_age_sub_splits) != 'undefined' && multi_active_age_sub_splits != null ) {
    // console.log(window.innerWidth);
    if( window.innerWidth > 750 ) {
      let i = 0;
      multi_active_age_sub_splits.forEach( element => {
        // console.log(i*200);
        element.animate(
          {
            transform: [
              "translateY(0)",
              "translateY(" + (i*60) + "px)"
            ],
          },
          {
            duration: 1, // required, but does nothing
            fill: 'both',
            timeline: new ScrollTimeline({
              scrollOffsets: [
                CSS.px(window.pageYOffset + element.getBoundingClientRect().top - 800),
                CSS.px(window.pageYOffset + element.getBoundingClientRect().top - 400)
              ]
            })
          }
        )
        i++;
      });
    }
  }
  i = 0;
  if( window.outerWidth > breakpoint ) {
    document.querySelectorAll('.rookie_academy_extended .reading_width > div:nth-child(odd)').forEach((ele) => {
      const x = 200 + (i*50);
      const ele_offset_top = ele.getBoundingClientRect().top + window.scrollY;
      const ele_height = ele.offsetHeight;
      const timeline = new ScrollTimeline({
        scrollOffsets: [
          CSS.px(ele_offset_top - window.innerHeight),
          CSS.px(ele_offset_top - (window.innerHeight*0.5))
        ]
      });
      ele.animate(
        {
          transform: [
            "translateY(" + x + "px) translateX(-100px)",
            "translateY(0) translateX(0)"
          ],
          opacity: [
            "0.5",
            "1"
          ]
        },
        {
          duration: 1,
          timeline: timeline
        }
      );
    });
    i = 0;
    document.querySelectorAll('.rookie_academy_extended .reading_width > div:nth-child(even)').forEach((ele) => {
      const x = 200 + (i*50);
      const ele_offset_top = ele.getBoundingClientRect().top + window.scrollY;
      const ele_height = ele.offsetHeight;
      const timeline = new ScrollTimeline({
        scrollOffsets: [
          CSS.px(ele_offset_top - window.innerHeight),
          CSS.px(ele_offset_top - (window.innerHeight*0.5))
        ]
      });
      ele.animate(
        {
          transform: [
            "translateY(" + x + "px) translateX(100px)",
            "translateY(0) translateX(0)"
          ],
          opacity: [
            "0.5",
            "1"
          ]
        },
        {
          duration: 1,
          timeline: timeline
        }
      );
    });
  }

}

jQuery( document ).ready(function() {
  if (document.querySelector('body.page-template-template-programmes, body.page-id-22732') ) {
    scroll_timelines__programmes();
  }
});

// window.addEventListener('scroll', function() {
//   console.log(document.documentElement.scrollTop);
// });
